import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

import IconCloseCart from '@/assets/icons/icon-close-cart.svg';
import IconExclamation from '@/assets/icons/icon-exclamation.svg';
import IconQuestionmark from '@/assets/icons/icon-questionmark.svg';

export const CartHeader = styled.div`
  position: sticky;
  top: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid ${colors.gray200};
  border-bottom: 1px solid ${colors.gray200};
  padding: 15px 12px;
  background-color: ${colors.white};
  z-index: 4;

  .btn-delete {
    cursor: pointer;
  }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const CartItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 12px;
`;

export const CartItemBadge = styled.div`
  display: inline-block;
  border-radius: 6px;
  background-color: ${colors.gray100};
  padding: 6px 8px;
  width: 65px;
`;

export const CartOrderDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 12px 10px 20px;
  border-radius: 8px;
  border: 1px solid ${colors.gray200};
`;

export const OrderDataHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  .cart-item-title {
    display: flex;
    gap: 10px;
    cursor: pointer;
  }
`;

export const OrderlineBody = styled.div`
  border-radius: 6px;
  border: 1px solid ${colors.gray200};
  background-color: ${colors.gray100};
  padding: 12px;
`;

export const OrderlineFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;

  .price-container {
    display: flex;
    align-items: center;
    gap: 6px;
  }
`;

export const DeliveryFeeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 6px;
`;

export const IconClose = styled.i`
  background-image: url(${IconCloseCart});
  background-repeat: no-repeat;
  background-position: center;
  width: 18px;
  height: 18px;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  position: relative;
`;

export const Icon = styled.div`
  position: relative;
  background-image: url(${IconQuestionmark});
  background-size: cover;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const EmptyCart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
  align-items: center;
  justify-content: center;
  height: 300px;

  .empty-icon {
    width: 69px;
    height: 69px;
    background-image: url(${IconExclamation});
    background-size: cover;
  }
`;

export const CartSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 10px;

  .summary-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .total-amount {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
  }
`;

export const Callout = styled.div`
  border-radius: 8px;
  padding: 12px;
  background-color: ${colors.gray100};
  margin-bottom: 60px;

  @media (max-width: 600px) {
    margin: 0 12px;
  }

  .callout-title {
    font-weight: 700 !important;
    margin-bottom: 6px;
  }

  li {
    position: relative;
    padding-left: 12px;
    font-family: 'Apple SD Gothic Neo';
    letter-spacing: -0.42px;

    &:not(:last-child) {
      margin-bottom: 6px;
    }
  }

  li::before {
    content: '・';
    font-size: 12px;
    position: absolute;
    left: 0;
    top: 4px;
    line-height: 1;
    color: ${colors.gray600};
  }
`;

export const FixedBottom = styled.section`
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 20px 12px 10px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.46) 0%,
    rgba(255, 255, 255, 0.84) 19.79%,
    rgba(255, 255, 255, 0.92) 61.46%,
    #fff 100%
  );

  backdrop-filter: blur(1px);

  @media (min-width: 600px) {
    max-width: 450px;
  }
`;
